import { useEffect } from "react";

export function useAIRoomSocket(socket, roomName, setWaitingForPrompts) {
  useEffect(() => {
    socket.emit("join room", roomName);
    socket.on("waitingForPrompts", () => setWaitingForPrompts(true));
    socket.on("stopWaitingForPrompts", () => setWaitingForPrompts(false));

    return () => {
      socket.off("connect");
      socket.off("waitingForPrompts");
      socket.off("stopWaitingForPrompts");
    };
  }, [socket, roomName, setWaitingForPrompts]);
}
